import * as React from "react";
import { cn } from "../lib/utils.js";

/**
 * Styled native checkbox — the shared equivalent design-system-spec §4.5
 * requires instead of ad-hoc `<input type="checkbox">` styling. Same class
 * contract as Input: token colours, focus-visible ring, opacity disabled.
 */
export const Checkbox = React.forwardRef<
  HTMLInputElement,
  Omit<React.InputHTMLAttributes<HTMLInputElement>, "type">
>(({ className, ...props }, ref) => (
  <input
    type="checkbox"
    ref={ref}
    className={cn(
      "h-4 w-4 shrink-0 accent-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      className
    )}
    {...props}
  />
));
Checkbox.displayName = "Checkbox";
